import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/actividadesAplicacion/actividadesAplicacion.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const ActivitiesApplicationViewModal = () => {
  const dispatch = useDispatch();
  const {
    viewModalOpen,
    selectedActividad,
    selectedActividadLoading,
    selectedActividadError,
  } = useSelector((state) => state.actividadesAplicacion);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de actividad"
      size="lg"
    >
      {selectedActividadLoading && (
        <Loader center text="Cargando actividad..." delay={150} type="dots" />
      )}

      {selectedActividadError && (
        <p className="text-danger">{selectedActividadError}</p>
      )}

      {!selectedActividadLoading && selectedActividad && (
        <div className="row g-4">
          <div className="col-12">
            <Field
              icon="mdi:checkbox-marked-circle-outline"
              label="Actividad"
              value={selectedActividad.nombre || selectedActividad.actividad}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:sort-numeric-variant"
              label="Orden"
              value={selectedActividad.orden || "-"}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:toggle-switch-outline"
              label="Estado"
              value={selectedActividad.is_active ? "Activa" : "Inactiva"}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:star-outline"
              label="Talento"
              value={selectedActividad.talento_nombre || "-"}
            />
          </div>

          <div className="col-12">
            <AuditInfo
              createdAt={selectedActividad.created_at}
              updatedAt={selectedActividad.updated_at}
              createdBy={selectedActividad.created_by}
              updatedBy={selectedActividad.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ActivitiesApplicationViewModal;
